import React from "react";

const ABOUT_IMG = "https://customer-assets.emergentagent.com/job_venue-events-hub/artifacts/rz93wc5z_nextli3.jpg";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-6">On Wilton Drive</p>
          <h2 className="font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight">
            Intimate nights, <span className="italic text-[#D4AF37]">big energy</span>.
          </h2>
          <div className="mt-8 space-y-5 text-neutral-300 leading-relaxed max-w-xl">
            <p>
              Located in the heart of Wilton Manors, Next Bar &amp; Lounge is an upscale, intimate lounge built around
              crafted cocktails, small plates and live entertainment. We trade volume for atmosphere so every night
              feels personal, immersive and memorable.
            </p>
            <p>
              We're more than a bar — we're an experience. Whether you're here for a crafted cocktail, a bite with
              friends, live music or late-night dancing, Next offers a warm, intimate setting where connection and
              atmosphere come first.
            </p>
          </div>
          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-neutral-800 pt-8">
            <div>
              <div className="font-serif text-3xl md:text-4xl text-white">7</div>
              <div className="text-xs tracking-[0.2em] uppercase text-neutral-500 mt-2">Nights / Week</div>
            </div>
            <div>
              <div className="font-serif text-3xl md:text-4xl text-white">Live</div>
              <div className="text-xs tracking-[0.2em] uppercase text-neutral-500 mt-2">Singing &amp; DJs</div>
            </div>
            <div>
              <div className="font-serif text-3xl md:text-4xl text-white">Late</div>
              <div className="text-xs tracking-[0.2em] uppercase text-neutral-500 mt-2">Dance Room</div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-6 order-1 lg:order-2 relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img src={ABOUT_IMG} alt="Velvet lounge" className="w-full h-full object-cover" />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
          </div>
          <div className="hidden md:block absolute -bottom-10 -left-10 w-40 h-40 border border-[#D4AF37]/40" />
        </div>
      </div>
    </section>
  );
}
